module.exports = __webpack_public_path__ + "shattered.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/styles/patterns/shattered.png
// module id = 1734
// module chunks = 11